import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Icon, Table, Card, Input, Button, Popup, Loader} from 'semantic-ui-react';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {paths} from '../../../../common/dictionaries/urls';
import {Actions} from '../../../../common/actions';

class WarehouseDenialCausesList extends Component {
  constructor(props) {
    super(props);
    this.onFilterChange = this.onFilterChange.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingWarehouseDenialCauses,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.changeWarehouseDenialCausesTextFilter('');
    this.props.fetchWarehouseDenialCausesList();
  }

  onFilterChange(event) {
    this.props.changeWarehouseDenialCausesTextFilter(event.target.value);
    this.props.filterWarehouseDenialCauses(event.target.value);
  }

  renderCreateButton() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingWarehouseDenialCauses,
        scopes.Create
      )
    ) {
      return null;
    }
    return (
      <Button
        primary
        className='toyota-primary'
        as={Link}
        to='/picking/warehouse-denied/nuevo'
      >
        Nueva Causa
      </Button>
    );
  }

  renderWarehouseDenialCauses(list) {
    if (!list.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={13}>
            No hay causas disponibles
          </Table.Cell>
        </Table.Row>
      );
    }

    return list.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.name}</Table.Cell>
          <Table.Cell textAlign='center'>
            {element.moveToTMP ? 'SI' : 'NO'}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {element.status ? 'Activo' : 'Inactivo'}
          </Table.Cell>
          {this.renderActionsCell(element)}
        </Table.Row>
      );
    });
  }

  renderLoaderOrDenialCauses(list) {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderWarehouseDenialCauses(list);
  }

  renderActionsHeader() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingWarehouseDenialCauses,
        scopes.Edit
      )
    ) {
      return null;
    }

    return <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>;
  }

  renderActionsCell(element) {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingWarehouseDenialCauses,
        scopes.Edit
      )
    ) {
      return null;
    }

    return (
      <Table.Cell textAlign='center'>
        <Popup
          trigger={
            <Link to={`/picking/warehouse-denied/editar/${element.code}`}>
              <Icon name='write' color='blue' size='large' />
            </Link>
          }
          content='Editar'
          position='top center'
          inverted
        />
      </Table.Cell>
    );
  }

  render() {
    const {warehouseDenialCauses, filterText} = this.props;
    return (
      <div className='warehouse-denial-causes-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Mantenimiento de Causas de Warehouse Denied</h2>
              <div className='title-bar-actions'>
                <Input
                  icon='search'
                  placeholder='Buscar'
                  value={filterText}
                  onChange={this.onFilterChange}
                />
                {this.renderCreateButton()}
              </div>
            </div>
          </div>
        </Card>

        <Card fluid raised>
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Causa</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Mover a TMP
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Estado</Table.HeaderCell>
                {this.renderActionsHeader()}
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {this.renderLoaderOrDenialCauses(warehouseDenialCauses)}
            </Table.Body>
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.warehouseDenialCauses.loading,
    'warehouseDenialCauses': state.warehouseDenialCauses.filteredList,
    'filterText': state.warehouseDenialCauses.filterText,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  fetchWarehouseDenialCausesList,
  filterWarehouseDenialCauses,
  changeWarehouseDenialCausesTextFilter,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchWarehouseDenialCausesList,
  filterWarehouseDenialCauses,
  changeWarehouseDenialCausesTextFilter,
  navigateTo,
})(WarehouseDenialCausesList);
